export default "__VITE_ASSET__B7Lj7Nac__"